"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.strategistRegionList = void 0;
exports.strategistRegionList = [
    {
        label: 'ANZ',
        value: 'ANZ',
    },
    {
        label: 'APAC 1',
        value: 'APAC_1',
    },
    {
        label: 'APAC 2',
        value: 'APAC_2',
    },
    {
        label: 'APAC 3',
        value: 'APAC_3',
    },
    {
        label: 'China',
        value: 'China',
    },
    {
        label: 'CIS',
        value: 'CIS',
    },
    {
        label: 'EU/UK',
        value: 'EU_UK',
    },
    {
        label: 'India',
        value: 'India',
    },
    {
        label: 'Japan',
        value: 'Japan',
    },
    {
        label: 'Korea',
        value: 'Korea',
    },
    {
        label: 'LatAm',
        value: 'LatAm',
    },
    {
        label: 'MESATI',
        value: 'MESATI',
    },
    {
        label: 'Singapore',
        value: 'Singapore',
    },
    {
        label: 'USCA',
        value: 'USCA',
    },
    {
        label: 'Global',
        value: 'Global',
    },
    {
        label: 'N/A',
        value: 'N/A',
    },
];
//# sourceMappingURL=strategistRegionList.js.map